/**
 * This module is imported in the following files:
 *
 *   - /gatsby-browser.js
 *   - /gatsby-ssr.js
 *   - /.storybook/preview.js
 *
 * All exports are re-exported in the gatsby-* files allowing access to the
 * Gatsby Browser and SSR APIs.
 *
 * @see https://www.gatsbyjs.org/docs/browser-apis/
 * @see https://www.gatsbyjs.org/docs/ssr-apis/
 */

import 'minireset.css'
import '@reach/skip-nav/styles.css'
import '@reach/accordion/styles.css'
import 'keen-slider/keen-slider.min.css'

// For some reason importing the CSS from siamese directly causes issues in
// production. For now, lets just duplicate the styles locally.
import './siamese.css'
import './index.css'

import * as React from 'react'
import { GatsbyBrowser } from 'gatsby'
import { PreviewStoreProvider } from 'gatsby-source-prismic'
import { TreatProvider } from 'react-treat'

import { DebugProvider } from './hooks/useDebug'
import { theme } from './theme.treat'
import { SpeedBumpModal } from './components/SpeedbumpModal'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => (
  <DebugProvider>
    <PreviewStoreProvider>
      <TreatProvider theme={theme}>
        {element}
        <SpeedBumpModal />
      </TreatProvider>
    </PreviewStoreProvider>
  </DebugProvider>
)
